import { Button, List, Popover } from "@material-ui/core";
import { Close, ExpandMore, SupervisorAccount } from "@mui/icons-material";
import { FC, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { Viewer } from "@/utilities/types/viewer";
import { LiveUnitViewersItem } from "@/views/liveUnitMosaic/LiveUnitViewers/LiveUnitViewersItem/LiveUnitViewersItem";

import useStyles from "./LiveUnitViewers.styles";


export interface LiveUnitViewersProps {
    /**
     * Flag indicating if the user who is viewing the page has view only access
     */
    displayViewOnly: boolean;

    /**
     * A list of other viewers
     */
    viewers: Viewer[];
}

export const LiveUnitViewers: FC<LiveUnitViewersProps> = ({ displayViewOnly, viewers }) => {
    const { t } = useTranslation("translation", { keyPrefix: "components.liveUnitMosaicPage.liveUnitViewers" });

    const [open, setOpen] = useState(false);
    const anchor = useRef<HTMLButtonElement>(null);
    const classes = useStyles();

    const onClick = () => setOpen(true);
    const onClose = () => setOpen(false);

    return (
        <>
            <Button
                ref={anchor}
                startIcon={<SupervisorAccount />}
                endIcon={<ExpandMore />}
                className={displayViewOnly ? classes.viewersButtonEmphasized : classes.viewersButton}
                id="viewers-button"
                onClick={onClick}
            >
                {viewers.length} {t("viewers")} &#8212; {displayViewOnly ? t("accessMessage.viewOnly") : t("accessMessage.cameraControl")}
            </Button>
            <Popover
                anchorEl={anchor.current}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                classes={{ paper: classes.popover }}
                onClose={onClose}
                open={open}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <div className={classes.menu} data-testid="viewers-menu">
                    <div className={classes.head}>
                        {t("title")}
                        <Close onClick={onClose} className={classes.close} data-testid="viewers-close" />
                    </div>
                    <List disablePadding className={classes.list} data-testid="viewers-list">
                        {viewers.map((viewer, i) => (
                            <LiveUnitViewersItem viewer={viewer} key={i} />
                        ))}
                    </List>
                </div>
            </Popover>
        </>
    );
};
